import React, { useState } from 'react';
import axios from 'axios';

const ForgotPassword = ({ setShowResetPasswordForm,setShowForgotPassword, setEmail, setMessage,t }) => {
  const [localEmail, setLocalEmail] = useState('');

  const handleSendOTP = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE}/send-otp`, { email: localEmail });
      setMessage(response.data.message);
      setEmail(localEmail);
      setShowResetPasswordForm(true);
      setShowForgotPassword(false)
    } catch (error) {
      setMessage(t('errorSendingOTP'));
      console.error('Error:', error);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', marginTop: '15px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', maxWidth: '300px' }}>
      <h2>{t('forgotPasswordTitle')}</h2>
      <label htmlFor="email" style={{ marginBottom: '5px' }}>{t('emailLabel')}</label>
          
      <input
        type="email"
        placeholder={t('enterEmailPlaceholder')}
        value={localEmail}
        onChange={(e) => setLocalEmail(e.target.value)}
        style={{ flexGrow: 1}}
          
          className='login-input'
      />
      <button onClick={handleSendOTP} className='btn-base'  style={{
                width: '100%',
                maxWidth: '300px',
                padding: '10px',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px',
                fontSize: '1rem'
              }}>{t('sendOTP')}</button>
    </div>
    </div>
  );
};

export default ForgotPassword;
